import Global from "@/scripts/Global";
import VueSignals from '@/scripts/VueSignals'

export default {
    name: 'ConfirmDeleteFF',
    data() {
        return {
            currData: {
                'ff_name': '',
                'ff_id': ''
            },
            confirmCheck: false,
        }
    },
    mounted() {
        this.currData = this.$parent.data
    },
    methods: {
        deleteFF() {
            if (this.confirmCheck) {
                if (Array.isArray(this.currData)) {
                    this.currData.forEach(currElem => {
                        Global.globalValue(VueSignals.DELETE_FF, currElem.ff_id)
                    })
                } else {
                    Global.globalValue(VueSignals.DELETE_FF, this.currData.ff_id)
                }
            }
        }
    }
}
